import {useMutation} from "@tanstack/react-query";

import {restoreSupplierMutationOptions} from "./restore-supplier.mutation-options";

export function useRestoreSupplier() {
  return useMutation(restoreSupplierMutationOptions());
}
